export default __webpack_public_path__ + "static/media/estacion-hidrogeno.5b0187a3.jpg";